export function setEsFE(state, newVal) {
  state.esFE = newVal ? '1' : '0'
}
